export const processingButtonStatuses = {
    success: 'success',
    error: 'error',
    'default': 'default',
};